<template>
  <div>
    <div class="content_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">我的包裹</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">未入库包裹</a></el-breadcrumb-item>
        <el-breadcrumb-item>更改物品信息</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">修改包裹物品信息</div>
      </div>
       <div class="operating_button_box">
          <div class="operating_button_l">
            <div class="operating_button_l_l">+添加箱号</div>
            <div class="operating_button_l_l color_2">-删除箱号</div>
          </div>
        </div>
        <div class="table_box">
          <el-radio v-model="radio" label=""> </el-radio>
          <div class="table_item">
            <div class="table_item_title_l">
              <div class="input_frg">
                <div class="case_number">箱号1</div>
                <!-- <div style="width: 70%; display: flex" class="">
                  <input
                    placeholder="请输入物品中文名称"
                    class="inout_uio"
                    style="background: #f1f3f6"
                    type="text"
                  />

                  <el-button class="button_L" type="primary">搜索</el-button>
                </div> -->
              </div>
              <div class="operating_button_l_l">+添加内件</div>
            </div>
            <div class="table_item_box">
              <div class="table_item_box_l">
                <div class="table_item_box_l_r">
                  <div class="fill_in_title">内件名称</div>
                  <div class="fill_in_title_l">*</div>
                  <input
                    type="text"
                    placeholder="请输入物品中文名称"
                    class="table_item_input"
                  />
                </div>
                <div class="table_item_box_l_r">
                  <div class="fill_in_title">申报价值</div>
                  <div class="fill_in_title_l">*</div>
                  <input
                    type="number"
                    placeholder="请输入申报价值"
                    class="table_item_input"
                  />
                  <span style="margin-left:5px"> RMB</span>
                </div>
              </div>
              <div class="table_item_box_l">
                <div class="table_item_box_l_r">
                  <div class="fill_in_title">品牌</div>
                  <div class="fill_in_title_l">*</div>
                  <input
                    type="text"
                    placeholder="请输入品牌"
                    class="table_item_input"
                  />
                </div>
                <div class="table_item_box_l_r">
                  <div class="fill_in_title">数量</div>
                  <div class="fill_in_title_l">*</div>
                  <input
                    type="number"
                    placeholder="请输入数量"
                    class="table_item_input"
                  />
                </div>
              </div>
              <div class="table_item_box_l">
                <div class="table_item_box_l_r">
                  <div class="fill_in_title">材质</div>
                  <div class="fill_in_title_l">*</div>
                  <el-select
                    class="input_select_table"
                    v-model="value6"
                    placeholder="请选择材质"
                  >
                    <el-option
                      v-for="item in cities"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <span style="float: left">{{ item.label }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                        >{{ item.value }}</span
                      >
                    </el-option>
                  </el-select>
                </div>
                <div class="table_item_box_l_r">
                  <div class="fill_in_title">种类</div>
                  <div class="fill_in_title_l">*</div>
                  <el-select
                    class="input_select_table"
                    v-model="value6"
                    placeholder="请选择国内快递公司"
                  >
                    <el-option
                      v-for="item in cities"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <span style="float: left">{{ item.label }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                        >{{ item.value }}</span
                      >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div>
                <div>
                  <el-upload
                    class="avatar-uploader"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </div>
              <div><div class="operating_button_l_l color_2">-删除</div></div>
            </div>
          </div>
        </div>
        <div class="step_box_s">

          <div class="last_step_l margin_right" @click="last_step($event, '4')">确认</div>
        </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.last_step_l {
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  line-height: 44px;
  border-radius: 22px;
  margin: 0 20px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 91px;
  height: 91px;
  background: #f5f5f5;
  opacity: 1;
  border-radius: 5px;
  line-height: 91px;
  text-align: center;
}
.avatar {
  width: 91px;
  height: 91px;
  background: #f5f5f5;
  opacity: 1;
  border-radius: 5px;
  display: block;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #ff0e0e;
}
.color_2 {
  border: 1px solid #ffa401 !important;
  color: #ffa401 !important;
}
.content_box_title {
  margin-top: 45px;
}
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 58px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.operating_button_box {
  display: flex;
  justify-content: flex-end;
  padding-right: 48px;
  box-sizing: border-box;
  margin-bottom: 15px;
}
.operating_button_l {
  display: flex;
}
.operating_button_l_l {
  width: 117px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #5178ff;
  opacity: 1;
  border-radius: 8px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 40px;
  text-align: center;
  margin-left: 12px;
  color: #5178ff;
}
.step_three {
  /* width: 90%; */

  box-sizing: border-box;
}
.table_box {
  width: 100%;
  height: auto;
  display: flex;
}
.table_item {
  width: 100%;
  height: auto;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
}
.table_item_title_l {
  display: flex;
  justify-content: space-between;
  padding: 25px 48px;
  box-sizing: border-box;
  align-items: center;
}
.case_number {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #2e3136;
  margin-right: 30px;
}
.table_item_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 48px;
  box-sizing: border-box;
  border-top: 1px solid #e1e1e1;
}
.table_item_box_l {
  margin-right: 50px;
}
.table_item_box_l_r {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  margin-bottom: 10px;
}
.table_item_input >>> .el-input__inner{
background: transparent;
  border: none !important;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #f1f3f6 !important;
  opacity: 1;
  border-radius: 5px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  border: none !important;
  font-weight: 400;
}
.input_select_table {
  background: #f1f3f6 !important;
  padding: 0 !important;
  width: 180px;
  height: 40px;
  background: #f1f3f6;
  opacity: 1;
  border-radius: 5px;
  margin-left: 10px;
  padding: 0 15px !important;
}
.input_select_table >>> .el-input__inner{
background: transparent;
  border: none !important;
}
.step_box_s {
  display: flex;
  justify-content: flex-end;
  margin-top: 58px;
}
.margin_right {
  margin-right: 0 !important;
}
.inout_uio {
  width: 502px;
  height: 40px;
  background: #f1f3f6 !important;
  opacity: 1;
  border-radius: 5px 0 0 5px;
  padding: 0 15px;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/views/undetermined/writeInformation.vue